var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoal1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.483 31.916L23.4263 32.9727C23.2358 33.1632 22.9775 33.2702 22.7082 33.2702H17.2915C17.0222 33.2702 16.7639 33.1632 16.5734 32.9727L15.5167 31.916H3.68213C3.12123 31.916 2.6665 32.3707 2.6665 32.9316V34.2858C2.6665 35.9686 4.03062 37.3327 5.71338 37.3327H34.2863C35.9691 37.3327 37.3332 35.9686 37.3332 34.2858V32.9316C37.3332 32.3707 36.8784 31.916 36.3175 31.916H24.483Z",
    fill: "url(#paint0_linear_28128_6388)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.255 12.2812H29.2585C30.2573 13.9207 30.8332 15.8449 30.8332 17.901C30.8332 23.8745 25.9733 28.7344 19.9998 28.7344C14.0263 28.7344 9.1665 23.8745 9.1665 17.901C9.1665 15.8449 9.74236 13.9207 10.7412 12.2812H7.74463C6.06458 12.2812 4.69775 13.6481 4.69775 15.3281V29.8854H15.9373C16.2067 29.8854 16.465 29.9925 16.6555 30.1829L17.7122 31.2396H22.2875L23.3442 30.1829C23.5346 29.9925 23.7929 29.8854 24.0623 29.8854H35.3019V15.3281C35.3019 13.6481 33.9351 12.2812 32.255 12.2812Z",
    fill: "url(#paint1_linear_28128_6388)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4961 4.9172L26.7979 3.28272C26.4691 2.51308 25.4029 2.4491 24.9844 3.17385L23.1224 6.39886C22.9625 6.67572 22.9424 7.01169 23.068 7.30561L24.3646 10.341L27.6417 9.94624C27.9591 9.90798 28.2399 9.7226 28.3997 9.44574L30.2617 6.22072C30.6801 5.4959 30.0915 4.60446 29.2606 4.7046L27.4961 4.9172Z",
    fill: "#4FB5F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9531 17.9004C16.9531 19.5804 18.32 20.9473 20 20.9473C21.68 20.9473 23.0469 19.5804 23.0469 17.9004C23.0469 17.1458 22.7711 16.4545 22.3152 15.9217L20.8795 18.4082C20.5991 18.8939 19.9779 19.0604 19.4922 18.7799C19.0064 18.4995 18.84 17.8783 19.1205 17.3926L20.5569 14.9046C20.3763 14.8711 20.1902 14.8535 20 14.8535C18.32 14.8535 16.9531 16.2203 16.9531 17.9004Z",
    fill: "#4FB5F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6326 12.1131L24.3551 12.3875L23.366 14.1007C24.4155 15.0316 25.078 16.3898 25.078 17.8997C25.078 20.6998 22.7999 22.9779 19.9998 22.9779C17.1998 22.9779 14.9217 20.6998 14.9217 17.8997C14.9217 15.0997 17.1998 12.8216 19.9998 12.8216C20.5617 12.8216 21.1026 12.9134 21.6082 13.0826L22.596 11.3718L21.6942 9.26056C21.1459 9.15372 20.5794 9.09766 19.9998 9.09766C15.1386 9.09766 11.1978 13.0385 11.1978 17.8997C11.1978 22.761 15.1386 26.7018 19.9998 26.7018C24.8611 26.7018 28.8019 22.761 28.8019 17.8997C28.8019 15.6845 27.9835 13.6603 26.6326 12.1131Z",
    fill: "#4FB5F9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28128_6388",
    x1: 2.6665,
    y1: 34.6243,
    x2: 37.3332,
    y2: 34.6243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28128_6388",
    x1: 4.69775,
    y1: 21.7604,
    x2: 35.3019,
    y2: 21.7604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B71F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB5F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal1);
export default __webpack_public_path__ + "static/media/goal_1.122ba0bc8558a4418ac41c351bff2f06.svg";
export { ForwardRef as ReactComponent };